import Cookies from "js-cookie";
import { getDomain } from "@jasper/shared";

/* Terminal segment, and not a substring: this seeds a session cookie from the URL, so it
   answers only to the route that is meant to carry one. */
const REMOTE_UPLOAD_ROUTE = /\/remote-upload\/?$/;
const SESSION_COOKIE = "Authentication";
const SESSION_DURATION_IN_DAYS = 1;

/** The session the remote upload link carries, undefined for any other URL. */
export const readRemoteUploadToken = (hash: string): string | undefined => {
  const [path, search] = hash.replace(/^#/, "").split("?");

  if (!REMOTE_UPLOAD_ROUTE.test(path) || !search) {
    return undefined;
  }

  return new URLSearchParams(search).get("token") || undefined;
};

export const storeRemoteUploadSession = (token: string) => {
  Cookies.set(SESSION_COOKIE, token, {
    expires: SESSION_DURATION_IN_DAYS,
    domain: getDomain(import.meta.env.MODE),
  });
};

/*
  The QR code carries the session in the URL, and the session check of `App` runs before
  the router mounts the page that would read it. Seeding the cookie here, before anything
  renders, is what keeps that first check from answering 401: the failed refresh that
  followed logged the visitor out, and its cookie removal landed after the page had
  written the token, wiping it.
*/
export const seedRemoteUploadSession = () => {
  const token = readRemoteUploadToken(window.location.hash);

  if (token) {
    storeRemoteUploadSession(token);
  }
};
